module.exports = __webpack_public_path__ + "assets/images/1FzdEx8ssl.png";


//////////////////
// WEBPACK FOOTER
// ../assets/images/index/banner.png
// module id = 1926
// module chunks = 0